import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=6bd24c9d&scoped=true&"
import script from "./SalesDashboard.vue?vue&type=script&lang=js&"
export * from "./SalesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd24c9d",
  null
  
)

export default component.exports